<template>
  <div class="connectors-management">
    <!-- Filter -->
    <FilterFrame ref="filter" :filter-form="filterSetting" class="filter-frame" @search="search" @clear="clearSearch()" />
    <div class="function">
      <div class="left">
        <div class="left-left">
          <div class="choose-count">
            選取 <span class="highlight">{{ selectionData.length }}</span> 個充電樁
          </div>
        </div>
        <div class="left-right">
          <el-button round :disabled="!selectionCanTurnOnMaintenance" @click="handleToggleBatchMaintenance('turnOn')">
            啟用維護
          </el-button>
          <el-button round :disabled="!selectionCanNotTurnOnMaintenance" @click="handleToggleBatchMaintenance('turnOff')">
            解除維護
          </el-button>
        </div>
      </div>
      <div class="right">
        <span class="result">搜尋結果共計 {{ totalCount }}筆</span>
      </div>
    </div>
    <!-- Table -->
    <el-table :data="dataList" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        v-for="[key, value] of Object.entries(logStructure) "
        :key="key"
        :prop="key"
        :label="value"
        width="120"
      >
        <template slot-scope="scope">
          <div class="regular">
            <pre>{{ scope.row[key] }}</pre>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="類型" width="120">
        <template slot-scope="scope">
          <div>{{ chargerTypeEnum[scope.row.ChargerType] || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="狀態" width="120">
        <template slot-scope="scope">
          <div
            :class="{
              'connectorStatus-error': [5, 6, 7, 8].includes(scope.row.ConnectorStatus),
              'connectorStatus-charging': [3].includes(scope.row.ConnectorStatus)}"
          >
            {{ connectorStatusEnum[scope.row.ConnectorStatus] || '-' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="充電槍規格">
        <template slot-scope="scope">
          <div>{{ scope.row.ConnectorType }}</div>
        </template>
      </el-table-column>
      <el-table-column label="電流" width="80">
        <template slot-scope="scope">
          <div v-if="scope.row.CurrentAmpere || scope.row.CurrentAmpere === 0">
            {{ `${scope.row.CurrentAmpere}A` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合約狀態" width="150">
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.ContractExpirationDate"
            :content="'到期日：' + $newFormatDate(scope.row.ContractExpirationDate, 'yyyy-MM-dd')"
            placement="top"
          >
            <div class="contract_normal" :class="scope.row.ContractStatus === 1 ? '' : 'contractExpired'">
              {{ scope.row.ContractStatus === 1 ? '生效中' : '已到期' }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="維護管控">
        <template slot-scope="scope">
          <div class="maintenance_normal" :class="{'inMaintenance': !scope.row.IsValid}">
            {{ scope.row.IsValid ? '正常' : '維護' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="350">
        <template slot-scope="scope">
          <div class="operate">
            <el-button v-if="scope.row.IsValid" size="mini" type="danger" plain @click="handleTogglePerMaintenance(scope.row.ConnectorSn, 'turnOn')">
              啟用維護
            </el-button>
            <el-button v-else size="mini" type="primary" plain @click="handleTogglePerMaintenance(scope.row.ConnectorSn, 'turnOff')">
              解除維護
            </el-button>
            <el-button v-if="scope.row.ConnectorStatus === 3" size="mini" type="danger" plain @click="handleStopCharging(scope.row.ConnectorSn)">
              停止充電
            </el-button>
            <el-button
              v-if="scope.row.ChargerType === 2 && loginUserInfo.IsAdmin"
              @click="onclickPrivateChargingAuthorized(scope.row.ConnectorSn)"
            >
              權限管理
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="isLoading" />
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      :current-page="nowPage"
      :total="totalCount"
      @current-change="getList"
    >
    </el-pagination>
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import { apiEvCharging } from '@/api/EvCharging'

export default {
  components: {
    FilterFrame,
    TableLoading
  },
  data () {
    const maxCount = 10
    const defaultReq = {
      'Paging.Offset': 0,
      'Paging.MaxCount': maxCount
    }
    const req = defaultReq
    return {
      selectionData: [],
      totalCount: 0,
      nowPage: 1,
      logStructure: {
        ConnectorSn: '充電樁代碼',
        Floor: '樓層',
        ConnectorName: '充電位置'

      },
      dataList: [],
      defaultReq,
      req,
      isLoading: false,
      maxCount,
      chargerTypeEnum: {
        1: '公共樁',
        2: '私有樁'
      },
      connectorStatusEnum: {
        1: '閒置',
        2: '準備中',
        3: '充電中',
        4: '停止充電',
        5: '無法使用',
        6: '發生錯誤',
        7: '離線中',
        8: '緊急停止'
      },
      filterSetting: [
        {
          label: '充電樁代碼',
          name: 'ConnectorSn',
          type: 'input',
          value: ''
        },
        {
          label: '類型',
          name: 'ChargerType',
          type: 'select',
          clearable: true,
          options: [
            { label: '公共樁', value: 'Public' },
            { label: '私有樁', value: 'Private' } // 還沒定義，先用此value
          ],
          value: ''
        },
        {
          label: '樓層',
          name: 'Floor',
          type: 'select',
          clearable: true,
          options: [], // 動態資料
          value: ''
        },
        {
          label: '狀態',
          name: 'ConnectorStatus',
          type: 'select',
          clearable: true,
          options: [
            { label: '閒置', value: 'Available' },
            { label: '準備中', value: 'Preparing' },
            { label: '充電中', value: 'Charging' },
            { label: '停止充電', value: 'Finishing' },
            { label: '無法使用', value: 'Unavailable' },
            { label: '發生錯誤', value: 'Faulted' },
            { label: '離線中', value: 'Offline' },
            { label: '緊急停止', value: 'Emergency' }
          ],
          value: ''
        },
        {
          label: '維護管控',
          name: 'ValidStatus',
          type: 'select',
          clearable: true,
          options: [
            { label: '正常', value: true },
            { label: '維護', value: false }
          ],
          value: ''
        },
        {
          label: '充電槍規格',
          name: 'ConnectorType',
          type: 'select',
          clearable: true,
          options: [], // 動態資料
          value: ''
        }
      ],
      loginUserInfo: JSON.parse(localStorage.getItem('loginUserInfo'))
    }
  },
  computed: {
    selectionCanTurnOnMaintenance () { // 勾選的checkbox中，有任一可以啟用維護
      return !this.selectionData.length || this.selectionData.some(o => o.IsValid)
    },
    selectionCanNotTurnOnMaintenance () { // 勾選的checkbox中，有任一可以解除維護
      return !this.selectionData.length || this.selectionData.some(o => !o.IsValid)
    }
  },
  mounted () {
    this.getDynamicFilter()
    this.getList()
  },
  methods: {
    selectable (row, index) {
      return row.selectable
    },
    onclickPrivateChargingAuthorized  (connectorSn) {
      this.$store.commit('triggerPrivateChargingAuthorizedDialog', true)
      this.$store.commit('triggerPrivateChargingConnectorSn', connectorSn)
    },
    handleSelectionChange (val) { // checkbox選擇變更
      this.selectionData = _cloneDeep(val)
    },
    getList (page = 1) {
      // 清空列表且呈現 loading 畫面
      this.dataList = []
      this.isLoading = true
      this.nowPage = page
      this.req['Paging.Offset'] = (page - 1) * 10
      apiEvCharging.Management.getConnectors(this.req).then(res => {
        this.dataList = res.data.Data.Connectors
        this.totalCount = res.data.Data.TotalCount
        this.isLoading = false
      }).catch(err => {
        console.log(err)
        this.isLoading = false
      })
    },
    getDynamicFilter () {
      apiEvCharging.Management.getFilterOptions().then(res => {
        // 樓層
        const floorRes = res?.data?.Data?.FloorOptions || []
        const floorOptions = floorRes.map(floorName => ({
          label: floorName,
          value: floorName
        }))
        const floorFilterIndex = this.filterSetting.findIndex(o => o.name === 'Floor')
        if (floorFilterIndex >= 0) { // 沒找到是-1
          this.filterSetting[floorFilterIndex].options = floorOptions
        }

        // 充電槍規格
        const connectorTypeRes = res?.data?.Data?.ConnectorTypeOptions || []
        const connectorTypeOptions = connectorTypeRes.map(typeName => ({
          label: typeName,
          value: typeName
        }))
        const connectorTypeFilterIndex = this.filterSetting.findIndex(o => o.name === 'ConnectorType')
        if (connectorTypeFilterIndex >= 0) { // 沒找到是-1
          this.filterSetting[connectorTypeFilterIndex].options = connectorTypeOptions
        }
      }).catch(err => {
        console.log(err)
      })
    },
    search (filterOptions) {
      this.req = { ...this.req, ...filterOptions }
      this.getList()
    },
    clearSearch () {
      this.req = this.defaultReq
      this.getList()
    },
    handleToggleBatchMaintenance (toggle) {
      if (!this.selectionData || !this.selectionData.length) return
      const confirmTitle = toggle === 'turnOn' ? '確定將所選的充電樁設為維護？' : '確定解除所選充電樁的維護管控？'
      const confirmText = toggle === 'turnOn' ? '設定後充電樁將轉為維護，並限制住戶使用' : '解除後充電樁將重新開放住戶使用'
      return this.$confirm(confirmText, confirmTitle, {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        const connectorSns = this.selectionData.map(o => o.ConnectorSn)
        this.toggleMaintenance(connectorSns, toggle)
      }).catch(err => {
        console.log(err)
      })
    },
    handleTogglePerMaintenance (connectorSn, toggle) {
      if (!connectorSn) return
      const confirmTitle = toggle === 'turnOn' ? '確定將此充電樁進行維護？' : '確定解除此充電樁的維護管控？'
      const confirmText = toggle === 'turnOn' ? '設定後充電樁將轉為維護，並限制住戶使用' : '解除後充電樁將重新開放住戶使用'
      return this.$confirm(confirmText, confirmTitle, {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        this.toggleMaintenance([connectorSn], toggle)
      }).catch(err => {
        console.log(err)
      })
    },
    toggleMaintenance (connectorSns, toggle) {
      if (!connectorSns) return
      const params = connectorSns.map(o => ({
        ConnectorSn: o,
        Changes: {
          IsValid: toggle !== 'turnOn' // 啟用維護 = 關閉樁
        }
      }))
      apiEvCharging.Management.patchConnectors(params).then(res => {
        if (toggle === 'turnOn') {
          this.$message({
            message: '成功設定維護',
            type: 'success'
          })
        }
        this.getList(this.nowPage)
      }).catch(err => {
        console.log(err)
      })
    },
    handleStopCharging (connectorSn) {
      if (!connectorSn) return
      return this.$confirm('確定要停止此充電樁？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        apiEvCharging.Management.PostForceStop(connectorSn).then(res => {
          this.getList(this.nowPage)
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.function {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 500px;
    border: 1px solid $black;
    border-radius: 10px;
    padding: 20px;
    .choose-count {
      font-size: 17px;
      font-weight: 600;
      .highlight {
        color: $mainColor;
      }
    }
  }
  .left-right {
    span {
      margin: 0 20px;
      color: $mainFontColor;
      vertical-align: middle;
    }
  }
  .right {
    .el-button > span {
      margin: 0 20px;
      color: $mainFontColor;
      vertical-align: middle;
    }
    .result {
      margin-left: 12px;
      font-size: 17px;
    }
  }
}
.connectors-management {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 25px;
  .maintenance_normal {
    color: $mainColor;
    &.inMaintenance {
      color: $dangerColor;
    }
  }
  .contract_normal {
    color: $mainColor;
    &.contractExpired {
      color: $dangerColor;
    }
  }
  .connectorStatus {
    &-charging {
      color: $mainColor;
    }
    &-error {
      color: $dangerColor;
    }
  }
  .highlight {
    color: $dangerColor;
  }
  .clickable {
    color: $mainColor;
    text-decoration: underline;
    cursor: pointer;
  }
  ::v-deep .el-table {
    @include basicTable(false);
  }
  ::v-deep .el-checkbox.is-disabled {
    display: none;
  }
  .operate {
    display: flex;
  }
}
</style>
